// removed by extract-text-webpack-plugin
module.exports = {"OrderInfo":"OrderInfo","OrderInfoDialog":"OrderInfoDialog","modal-content":"modal-content","ModalBody":"ModalBody","OrderInfoTable":"OrderInfoTable","OrderInfoTitle":"OrderInfoTitle","OrderLog":"OrderLog","OrderLogTitle":"OrderLogTitle","OrderLogTable":"OrderLogTable","CloseButton":"CloseButton"};


//////////////////
// WEBPACK FOOTER
// ./src/components/areas/Account/OrderBook/OrderInfo/styles.scss
// module id = 2020
// module chunks = 10